'use client';

import { useContext } from 'react';
import { DestinationFilter } from './DestinationFilter';

const EMPTY_FILTERS = [];
const noop = () => {};

export function useDestinationFilter() {
  const ctx = useContext(DestinationFilter);
  if (!ctx) {
    return { categoryFilters: EMPTY_FILTERS, setCategoryFilters: noop };
  }
  return ctx;
}
